import { Component } from '@angular/core';
import {NgFor} from "@angular/common";

@Component({
  selector: 'app-important-be',
  standalone: true,
  imports: [NgFor],
  templateUrl: '../../importancia-items/importancia-items.component.html',
  styleUrl: './important-be.component.css'
})
export class ImportantBEComponent {
  items = [
    {
      name: "Cumplimiento normativo",
      description: "Garantiza que la empresa cumpla con las leyes y regulaciones de seguridad laboral, evitando sanciones legales.",
      icon: "/assets/img/enterprise/iconosImportancia/cumplimientoNormativo.svg"
    },
    {
      name: "Abastecimiento continuo",
      description: "Asegura que los botiquines estén siempre equipados con los insumos necesarios y en óptimas condiciones.",
      icon: "/assets/img/enterprise/iconosImportancia/abastecimientoContinuo.svg"
    },
    {
      name: "Respuesta inmediata",
      description: "Facilita la atención oportuna en caso de emergencias o accidentes, reduciendo riesgos para los colaboradores.",
      icon: "/assets/img/enterprise/iconosImportancia/respuestaInmediata.svg"
    },
    {
      name: "Promueve el bienestar laboral",
      description: "Refleja un compromiso con la salud y seguridad de los colaboradores, mejorando su confianza y productividad.",
      icon: "/assets/img/enterprise/iconosImportancia/bienestarLaboral.svg"
    }

  ]

}
